// Состояние: три независимых сетки (книги, писатели, поэты), тема, выбранная ячейка.
// Хранится в localStorage целиком: картинки в ячейках — уменьшенные JPEG data-URL.

export const KEY = 'pierogi-books9:v1';
export const N = 9;

export const MODES = {
  books: {
    label: 'Книги', title: 'Мои 9 любимых книг', search: 'Название книги или автор',
    nameLabel: 'Название', subLabel: 'Автор', imgWord: 'обложка', hash: 'knigi', notFound: 'книги',
  },
  writers: {
    label: 'Писатели', title: 'Мои 9 любимых писателей', search: 'Имя писателя',
    nameLabel: 'Имя', subLabel: 'Подпись', imgWord: 'портрет', hash: 'pisateli', notFound: 'автора',
  },
  poets: {
    label: 'Поэты и стихи', title: 'Мои 9 любимых поэтов', search: 'Имя поэта',
    nameLabel: 'Поэт', subLabel: 'Стихотворение', imgWord: 'портрет', hash: 'poety', notFound: 'поэта',
  },
};
export const MODE_IDS = Object.keys(MODES);

export const emptyCell = () => ({ title: '', sub: '', img: '' });

export function newState() {
  const docs = {};
  for (const id of MODE_IDS) docs[id] = { title: MODES[id].title, cells: Array.from({ length: N }, emptyCell) };
  return { mode: 'books', theme: 'dark', sel: 0, docs };
}

const str = (v, max) => (typeof v === 'string' ? v.slice(0, max) : '');

// Любая порча сохранённого → безопасное значение по умолчанию.
export function normalize(raw) {
  const s = newState();
  if (!raw || typeof raw !== 'object') return s;
  if (MODE_IDS.includes(raw.mode)) s.mode = raw.mode;
  if (raw.theme === 'light') s.theme = 'light';
  for (const id of MODE_IDS) {
    const d = raw.docs && raw.docs[id];
    if (!d) continue;
    if (typeof d.title === 'string') s.docs[id].title = d.title.slice(0, 80);
    if (Array.isArray(d.cells)) {
      s.docs[id].cells = Array.from({ length: N }, (_, i) => {
        const c = d.cells[i] || {};
        const img = typeof c.img === 'string' && /^data:image\/(jpeg|png);base64,/.test(c.img) ? c.img : '';
        return { title: str(c.title, 120), sub: str(c.sub, 120), img };
      });
    }
  }
  return s;
}

// Адаптер хранилища для Board: в приложении — localStorage, в тестах — память.
// load() → сохранённый объект или null; save(obj) → удалось ли записать.
export const browserStorage = {
  load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } },
  save(obj) { try { localStorage.setItem(KEY, JSON.stringify(obj)); return true; } catch { return false; } },
};
